<template>
  <div
    :class="{
      'image-text-tile-fi': true,
      'image-text-tile-fi--xpe': isEditMode,
      'image-text-tile-fi--dark': dark,
    }"
  >
    <div
      class="image-text-tile-fi__image-container"
      :style="imageRatio"
    >
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="isEditMode && fields.image"
        class="image-text-tile-fi__image-editor"
        v-html="fields.image.editable"
      />
      <!-- eslint-enable vue/no-v-html -->
      <!--
        For some reason a v-else here will cause the ssr-cloud-image-fi to not
        render in ssr. Using v-show as a workaround.
      -->
      <ssr-cloud-image-fi
        v-show="!isEditMode"
        :field="fields.image"
        :breakpoints="breakpoints"
        :unlimited="unlimited"
        class="image-fi__img"
      />
    </div>
    <div class="image-text-tile-fi__content-wrapper">
      <!-- eslint-disable vue/no-v-html -->
      <h3
        v-if="isEditMode"
        class="image-text-tile-fi__headline fi-text-size-df-18"
        v-html="fields.headline.editable"
      />
      <h3
        v-else-if="fields.headline?.value"
        class="image-text-tile-fi__headline fi-text-size-df-18"
        v-html="fields.headline.value"
      />
      <!-- eslint-enable vue/no-v-html -->

      <richtext-fi
        v-if="fields.content?.value || isEditMode"
        ref="rteContent"
        class="image-text-tile-fi__content"
        :html-content="fields.content"
      />
    </div>
  </div>
</template>

<script>
import { RichtextFi, SsrCloudImageFi } from 'atoms';

export default {
  name: 'ImageTextTileFi',
  components: {
    RichtextFi,
    SsrCloudImageFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    dark: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    breakpoints() {
      return [
        {
          mediaWidth: 480,
          imageWidth: 444,
        },
        {
          mediaWidth: 767,
          imageWidth: 731,
        },
        {
          mediaWidth: 768,
          imageWidth: 345,
        },
        {
          mediaWidth: 1023,
          imageWidth: 473,
        },
        {
          mediaWidth: 1440,
          imageWidth: 444,
        },
        {
          mediaWidth: 1920,
          imageWidth: 604,
        },
      ];
    },
    unlimited() {
      return 395;
    },
    imageRatio() {
      if (this.fields.image?.value?.width && this.fields.image?.value?.height) {
        return `aspect-ratio: ${this.fields.image.value.width} / ${this.fields.image.value.height}`;
      }

      return null;
    },
  },
};
</script>

<style lang="scss">
@import './image-text-tile-fi-unscoped';
</style>
